routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
    $stateProvider
        .state('home.address', {
            url: __env.routes.address,
            template: `<address sh-ctrl="shCtrl"></address>`
        });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/address/address.config.js
 **/